import script from "./percentage.vue?vue&type=script&setup=true&lang=ts"
export * from "./percentage.vue?vue&type=script&setup=true&lang=ts"

import "./percentage.vue?vue&type=style&index=0&id=40cbb4c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cbb4c0"]])

export default __exports__